import Button from './Button';
import { ButtonProps, ButtonValueProps, ButtonCombinedProps } from './types';

export type { ButtonProps, ButtonValueProps, ButtonCombinedProps };
export default Button;
